<template>
  <div class="form-group">
    <label>{{ question.statement }}</label>
    <select class="form-control" @change="onBooleanAnswerChange" :value="getBooleanAnswerValue()" :disabled="disabledAttribute">
      <option :value="'true'">Sim</option>
      <option :value="'false'">Não</option>
    </select>
    <p class="text-red" v-if="m_error">{{ m_error }}</p>
    <div class="row" v-if="getBooleanAnswerValue()">
      <div
        v-bind:class="[ rowsWhenTrueLength === 1 ? 'col-xs-12' : 'col-sm-6' ]"
        v-for="rowCounter in rowsWhenTrueLength">
        <div class="box box-solid box-primary">
          <div class="box-body">
            <component
              v-for="f in question.fieldsWhenTrue"
              v-bind:key="f.uuid"
              ref="fieldsWhenTrue"
              v-on:fieldUpdated="onFieldUpdated"
              :is="getFieldComponent(f)"
              :field="f"
              :fieldAnswer="getFieldAnswer(rowCounter, f)"
              :isDisabled="disabledAttribute"
              >
            </component>
          </div>
        </div>
      </div>
    </div>

    <div class="row"  v-if="getBooleanAnswerValue() && !disabledAttribute">
      <div class="col-xs-6">
        <button
          class="btn btn-sm btn-default center-block pull-right"
          v-on:click.prevent="removeRow">
          <i class="fa fa-minus"></i>
        </button>
      </div>
      <div class="col-xs-6">
        <button
          class="btn btn-sm btn-default center-block pull-left"
          v-on:click.prevent="addRow">
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import CNPJField from './fields/CNPJField'
  import StringField from './fields/StringField'
  import YearField from './fields/YearField'
  import EmailField from './fields/EmailField'
  import PhoneNumberField from './fields/PhoneNumberField'
  import MultipleChoiceField from './fields/MultipleChoiceField'
  import IntegerField from './fields/IntegerField'

  export default {
    props: ['question', 'answer', 'isDisabled'],
    name: 'BooleanCollectionQuestion',
    data () {
      return {
        componentsPerType: {
          'cnpj': CNPJField,
          'string': StringField,
          'year': YearField,
          'email': EmailField,
          'phone_number': PhoneNumberField,
          'multiple-choice': MultipleChoiceField,
          'integer': IntegerField
        },
        m_answer: {
          questionUuid: this.question.uuid,
          value: {
            booleanAnswer: this.answer.value && this.answer.value.booleanAnswer !== null ? this.answer.value.booleanAnswer : null,
            rowsWhenTrue: this.answer.value && this.answer.value.rowsWhenTrue ? this.answer.value.rowsWhenTrue : []
          }
        },
        m_error: null
      }
    },
    mounted () {
      this.question = this.sortQuestionFieldsByRenderingOrder(this.question)

      if (this.rowsWhenTrueLength === 0 && this.m_answer.value.booleanAnswer) {
        this.addRow()
      }
    },
    computed: {
      rowsWhenTrueLength () {
        return this.m_answer.value.rowsWhenTrue.length
      },
      disabledAttribute () {
        return this.question.disabled === true || this.isDisabled === true
      }
    },
    watch: {
      m_answer: {
        handler () {
          this.$emit('answerUpdated', this.m_answer)
        },
        deep: true
      }
    },
    methods: {
      onBooleanAnswerChange (data) {
        this.m_answer.value.booleanAnswer = (data.target.value === 'true')
        if (!this.m_answer.value.booleanAnswer) {
          this.m_answer.value.rowsWhenTrue = []
          return
        }

        if (this.m_answer.value.rowsWhenTrue.length < 1) {
          this.addRow()
        }
      },
      getBooleanAnswerValue () {
        return this.m_answer.value.booleanAnswer
      },
      onFieldUpdated (rowIndex, newFieldAnswer) {
        let fieldAnswerFound = false
        const row = this.m_answer.value.rowsWhenTrue[rowIndex]
        for (let fieldIndex in row) {
          let fieldAnswer = row[fieldIndex]
          if (fieldAnswer.fieldUuid === newFieldAnswer.fieldUuid) {
            fieldAnswer.value = newFieldAnswer.value
            fieldAnswerFound = true
          }
        }
        if (!fieldAnswerFound) {
          throw new Error('FieldAnswerNotFoundException')
        }
      },
      removeRow () {
        this.m_answer.value.rowsWhenTrue.pop()
      },
      addRow () {
        let emptyAnswer = []
        this.question.fieldsWhenTrue.forEach(field => {
          emptyAnswer.push({ 'fieldUuid': field.uuid, 'value': null })
        })
        this.m_answer.value.rowsWhenTrue.push(emptyAnswer)
      },
      getFieldComponent (f) {
        return this.componentsPerType[f.type]
      },
      getFieldAnswer (rowCounter, field) {
        let fieldAnswerFound = false
        const rowIndex = rowCounter - 1
        const row = this.m_answer.value.rowsWhenTrue[rowIndex]
        for (let fieldIndex in row) {
          const fieldAnswer = row[fieldIndex]
          if (fieldAnswer.fieldUuid === field.uuid) {
            fieldAnswerFound = true
            return { 'rowIndex': rowIndex, 'value': fieldAnswer.value }
          }
        }
        if (!fieldAnswerFound) {
          throw new Error('FieldAnswerNotFoundException')
        }
      },
      sortQuestionFieldsByRenderingOrder (question) {
        question.fieldsWhenTrue.sort(function (a, b) {
          return a.renderingOrder - b.renderingOrder
        })
        return question
      },
      isValid () {
        this.m_error = null

        if (this.question.required && this.m_answer.value.booleanAnswer === null) {
          this.m_error = 'Esta campo é de preenchimento obrigatório'
          return false
        }

        let areFieldAnswersBlank = true
        for (let rowIndex in this.m_answer.value.rowsWhenTrue) {
          for (let fieldIndex in this.m_answer.value.rowsWhenTrue[rowIndex]) {
            if (this.m_answer.value.rowsWhenTrue[rowIndex][fieldIndex].value) {
              areFieldAnswersBlank = false
            }
          }
        }
        if (!this.question.required && areFieldAnswersBlank) {
          this.m_answer.value.rowsWhenTrue = []
          return true
        }

        if (!this.$refs.fieldsWhenTrue) {
          return true
        }

        let areFieldAnswersValid = true
        this.$refs.fieldsWhenTrue.forEach(f => {
          if (!f.isValid()) {
            areFieldAnswersValid = false
          }
        })

        return areFieldAnswersValid
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BooleanCollectionQuestion.vue?3ea9a1db